const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getSites(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/sites`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view sites');
    }
    throw new Error('Failed to fetch sites');
  }
  
  const data = await response.json();
  return data.sites;
}

export async function getSite(orgId, siteId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/sites/${siteId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Site not found');
    }
    if (response.status === 403) {
      throw new Error('You do not have permission to view this site');
    }
    throw new Error('Failed to fetch site');
  }
  
  const data = await response.json();
  return data.site;
}
